import Vue from '../main'

export default {
  getPerfil() {
    return Vue.$http.get(`${process.env.VUE_APP_ROOT_API}vue/session`);
  }
}
